exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ml-15[data-v-2d5344ca]{margin-left:15px}.fl-r[data-v-2d5344ca]{float:right}.mt-20[data-v-2d5344ca]{margin-top:20px}.mr-20[data-v-2d5344ca]{margin-right:20px}#print[data-v-2d5344ca]{display:none}.tableColumns[data-v-2d5344ca]{height:auto;float:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-2d5344ca","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/pharmacy/inventory/detail.vue
// module id = Otc4
// module chunks = 0